<template>
  <div style="height: 60vh">
    <audio id="scanSuccessmp3" src="public/audio/ScanFailure.mp3"/>
    <audio id="scanFailuremp3" src="public/audio/ScanFailure.mp3"/>
    <div style="text-align: center;">
      <span class="text" style="font-size: 20px">送货单号:  </span>
      <span>
        <input
            ref="purchaseReceiveNo"
            v-model="purchaseReceiveNo"
            style="width: 300px;border: 1px solid #e6e6e6;font-size: 18px;padding: 7px 15px"
            placeholder="请扫描送货单号或手动输入后回车"
            @change="getKZGManageScanCDS"></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    components: {},
    data() {
      return {
        purchaseReceiveNo:"",
      };
    },
    methods: {
      audioPlay(val) {
        let musicMp3 = document.getElementById(val);
        musicMp3.play();
      },
      audioStop(val) {
        let musicMp3 = document.getElementById(val);
        musicMp3.pause();
      },
      getKZGManageScanCDS() {
        if(this.purchaseReceiveNo) {
          let purchaseReceiveNos = [];
          purchaseReceiveNos.push(this.purchaseReceiveNo);
          this.$http
            .post("basic", "purchaseReceives/aogScan",purchaseReceiveNos)
            .then(() => {
              this.$message.success("扫描成功");
              this.$refs["purchaseReceiveNo"].focus();
              this.purchaseReceiveNo = "";
              this.audioPlay("scanSuccessmp3");
              this.audioStop("scanFailuremp3");
            })
            .catch(() => {
              this.$message.error("扫描失败！");
              this.$refs["purchaseReceiveNo"].focus();
              this.purchaseReceiveNo = "";
              this.audioPlay("scanSuccessmp3");
              this.audioStop("scanFailuremp3");
            });
        }
      },
    },
  };
</script>

<style lang="scss">


</style>
